import { CIPageHeader, CIStatusCapsule } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import classes from './AssociationHeader.module.scss';

const getStickyStyle = (isSticky: boolean, ifClassString: string, orClassString: string) => (isSticky ? ifClassString : orClassString);

interface IAssociationHeader {
  header: string | undefined;
  subHeader: string | undefined;
  description: string | undefined;
  version: string | number | undefined;
  status: string | undefined;
  containerId: string | undefined;
  containerHeaderId: string | undefined;
}

const AssociationHeader = ({ header, subHeader, version, description, status, containerId, containerHeaderId }: IAssociationHeader) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (containerId && containerHeaderId) {
      const windowScrollStickyHeader = () => {
        const documentHeight = document.getElementById(containerId)?.clientHeight;
        const windowHeight = window.innerHeight;
        const headerHeight = document.getElementById(containerHeaderId)?.clientHeight;
        const sticky = headerHeight ?? 0;

        if (window.scrollY > sticky && documentHeight && ((windowHeight - sticky - 10) < documentHeight)) {
          setIsSticky(true);
        } else if (window.scrollY <= sticky - 20) {
          setIsSticky(false);
        }
      };
      window.addEventListener('scroll', windowScrollStickyHeader);
      return (() => {
        window.removeEventListener('scroll', windowScrollStickyHeader);
      });
    }
    // Add a return statement here
    return () => { };
  }, []);

  return (
    <Row className={`${classes['association-header-container']} ${getStickyStyle(isSticky, classes['sticky-association-header-container'], '')}`}>
      <Col md={12}>
        <div className={classes['association-title']} {...(containerHeaderId && { id: containerHeaderId })}>
          <CIPageHeader header={`${header}`} className={`${getStickyStyle(isSticky, classes['sticky-association-title'], '')}`} />
          {subHeader && <div className={classes['subheader-text']}>{subHeader}</div>}
          {status && <div className={classes.status}><CIStatusCapsule status={status} /></div>}
        </div>

        {
          version && (
            <p className={`${getStickyStyle(isSticky, classes['sticky-version-text'], classes['version-text'])}`}>
              {`Ver ${version}`}
            </p>
          )
        }

        {description && !isSticky && <p className={classes['description-text']}>{description}</p>}
      </Col>
    </Row>
  );
};

export default AssociationHeader;
